import { assign } from "xstate";
import { track } from "../../actions";
export const summaryScreenState = {
    entry: [track],
    on: {
        INFORMATION: "information",
        PRICE: "price",
        BACK: "information",
        NEXT: "confirmation",
        SET_ADDITIONAL_PRODUCTS: {
            actions: assign({
                additionalProducts: (_ctx, event) => event.additionalProducts,
            }),
        },
        SET_SIGN_ID: {
            actions: assign({
                signId: (_ctx, event) => event.signId,
            }),
        },
    },
};
